import axiosInstance from "./AxiosInstance";

export function getCompanySalesList(data) {
  return axiosInstance.post(`/sales/list`, data);
}

export function detailsCompanySales(data) {
  return axiosInstance.post(`/sales/details`, data);
}

export function updateCompanySalesStatus(data) {
  return axiosInstance.post(`/sales/status-update`, data);
}

export function getEcommerceCompanyList(data) {
  return axiosInstance.post(`/ecommerce-company-list`, data);
}

export function getEcommerceSalesDetailsList(data) {
  return axiosInstance.post(`/sales/details`, data);
}

export function getpendingSales(data) {
  return axiosInstance.get(`/sales/get-pending-sales`, data);
}

export function getdetailsPdfDownloadSales(data) {
  return axiosInstance.post(`/sales/detailsPDf`, data);
}

export function internalSalesUpdateStatus(data) {
  return axiosInstance.post(`/internal-sales/status-update`, data);
}

export function internalSalesRefundStatus(data) {
  return axiosInstance.post(`/internal-sales/refund-status`, data);
}

export function internalSalesFileUpdate(data) {
  return axiosInstance.post(`/internal-sales/file-update`, data);
}

export function internalSalesInvoicePdf(data) {
  return axiosInstance.post(`/internal-sales/invoice/pdf`, data);
}

export function createInpvoiceInternalSales(data) {
  return axiosInstance.post(`/internal-syncproduct`, data);
}

export function deleteInvoiceFileInternalSales(data) {
  return axiosInstance.post(`/delete-invoice-file`, data);
}

export function getCheckMCustomer(data) {
  return axiosInstance.post(`/check-m-customer`, data);
}

export function createmarketPlaceInvoice(data) {
  return axiosInstance.post(`/mrketplace-invoice`, data);
}

export function createInternalInvoice(data) {
  return axiosInstance.post(`/internal-invoice`, data);
}








